export default __webpack_public_path__ + "static/media/photo02_pc.6714992c.jpg";